import { styled } from '@mui/material/styles';
import { ListItem, ListItemIcon, Drawer, List } from '@mui/material';

const drawerWidth = '21rem';

export const StyledRoot = styled('div')(({ theme }) => ({
	paddingTop: 'env(safe-area-inset-top)',
	flexShrink: 0,
	[theme.breakpoints.up('md')]: {
		width: '21rem' // Keep width on larger screens
	},
	[theme.breakpoints.down('md')]: {
		width: 0 // Adjust width for mobile and tablets
	}
}));

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
	maxWidth: '21rem',
	width: '100%', // Let it adjust dynamically
	flexShrink: 0,
	'& .MuiDrawer-paper': {
		maxWidth: '21rem',
		width: '100%', // Responsive width
		boxSizing: 'border-box',
		borderRight: '1px solid rgba(10, 57, 129, 0.2)',
		background: 'linear-gradient(135deg, #ffffff 0%, #f7f9fc 100%)',
		overflowY: 'auto',
		overflowX: 'hidden'
	}
}));

export const StyledSidebar = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	width: '100%'
});

export const StyledSidebarContent = styled('div')({
	width: drawerWidth,
	overflowY: 'overlay', // Changed from 'auto' to 'overlay'
	overflowX: 'hidden',
	paddingLeft: '16px', // Add padding to account for scrollbar
	paddingBottom: '16px', // Add padding to account for scrollbar
	boxSizing: 'border-box'
});

export const StyledSidebarList = styled(List)({});

export const StyledSidebarItem = styled(ListItem, {
	shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isExternal'
})(({ isActive, theme }) => ({
	padding: '8px 16px',
	display: 'flex',
	alignItems: 'center',
	textDecoration: 'none',
	color: '#333333',
	borderTopLeftRadius: 8,
	borderBottomLeftRadius: 8,
	borderTopRightRadius: 0,
	borderBottomRightRadius: 0,
	width: '100%',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: 'rgba(10, 57, 129, 0.08)'
	},
	...(isActive && {
		backgroundColor: 'rgba(10, 57, 129, 0.16)',
		color: '#0A3981',
		'&:hover': {
			backgroundColor: 'rgba(10, 57, 129, 0.24)'
		},
		'& .MuiListItemIcon-root': {
			color: '#0A3981'
		},
		'& .MuiListItemText-primary': {
			color: '#0A3981',
			fontWeight: 600
		}
	})
}));

export const StyledSubItem = styled(ListItem, {
	shouldForwardProp: (prop) => prop !== 'isActive'
})(({ isActive, theme }) => ({
	padding: '8px 16px',
	paddingLeft: '56px', // Align with the text of parent items (24px icon + 16px padding + 16px gap)
	display: 'flex',
	alignItems: 'center',
	textDecoration: 'none',
	color: '#333333',
	borderTopLeftRadius: 8,
	borderBottomLeftRadius: 8,
	borderTopRightRadius: 0,
	borderBottomRightRadius: 0,
	marginLeft: 'auto',
	width: '100%',
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: 'rgba(10, 57, 129, 0.08)'
	},
	...(isActive && {
		backgroundColor: 'rgba(10, 57, 129, 0.16)',
		color: '#0A3981',
		'&:hover': {
			backgroundColor: 'rgba(10, 57, 129, 0.24)'
		},
		'& .MuiListItemText-primary': {
			color: '#0A3981',
			fontWeight: 600
		}
	})
}));

export const StyledListItemIcon = styled(ListItemIcon)({
	minWidth: '24px',
	marginRight: '16px'
});
